import * as anchor from "@project-serum/anchor";
import { WalletModalProvider } from "@solana/wallet-adapter-ant-design";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import {
  LedgerWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolflareWalletAdapter,
  SolletExtensionWalletAdapter,
  SolletWalletAdapter,
  TorusWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";
import "antd/dist/antd.min.css";
import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GameBoard } from "./pages/GameBord";
import { PongPage } from "./pages/Pong";
import { Styles } from "./styles/styles";
require("@solana/wallet-adapter-ant-design/styles.css");
// const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

export const App = () => {
  const [rpcHost, setRpcHost] = useState<string>(
    localStorage.getItem("rpc") as string
  );

  useEffect(() => {
    if (localStorage.getItem("rpc")) {
      setRpcHost(localStorage.getItem("rpc") as string);
    }
  }, []);

  const endpoint = useMemo(
    () => (rpcHost ? rpcHost : clusterApiUrl("mainnet-beta")),
    [rpcHost]
  );
  console.log({ endpoint });
  // const endpoint = useMemo(() => clusterApiUrl(network), []);

  const network = WalletAdapterNetwork.Devnet;

  console.log("network", network);

  // You can also provide a custom RPC endpoint
  // const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({ network }),
      new TorusWalletAdapter(),
      new LedgerWalletAdapter(),
      new SolletWalletAdapter({ network }),
      new SolletExtensionWalletAdapter({ network }),
    ],
    [network]
  );
  return (
    <BrowserRouter>
      <Styles />
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletModalProvider>
            <Routes>
              <Route path="/confirmed" element={<GameBoard />} />
              <Route path="/" element={<PongPage />} />
            </Routes>
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </BrowserRouter>
  );
};
